import type { AasApiAdapter } from "../adapter";
import { requestJson } from "../http";
import type { AgentFileRecord } from "../types";
import type { BackendProfileFile } from "./backendTypes";

export function mapProfileFile(file: BackendProfileFile): AgentFileRecord {
	return {
		id: file.id,
		path: file.path,
		sizeKb: Math.max(1, Math.round(file.sizeBytes / 1024)),
		uploadedAt: file.updatedAt ?? file.createdAt,
	};
}

export const profileFilesApi: AasApiAdapter["agentFiles"] = {
	async list(slug: string) {
		const files = await requestJson<BackendProfileFile[]>(
			`/api/agents/${encodeURIComponent(slug)}/files`,
		);
		return files.map(mapProfileFile);
	},
	async getContent(slug: string, path: string) {
		const result = await requestJson<{ content: string }>(
			`/api/agents/${encodeURIComponent(slug)}/files/${path}`,
		);
		return result.content;
	},
	async upload(slug: string, files: Array<{ path: string; content: string }>) {
		if (files.length === 0) {
			return;
		}
		await requestJson(`/api/agents/${encodeURIComponent(slug)}/files`, {
			method: "POST",
			body: { files },
		});
	},
	async delete(slug: string, path: string) {
		await requestJson<void>(`/api/agents/${encodeURIComponent(slug)}/files/${path}`, {
			method: "DELETE",
		});
	},
};
